var SmoothScroll = (function() {

	// https://github.com/alicelieutier/smoothScroll

	var easeInOutCubic = function (t) {
		return (t < 0.5) ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1;
	};

	var position = function(start, end, elapsed, duration) {
		if (elapsed > duration) {
			return end;
		}
		return start + (end - start) * easeInOutCubic(elapsed / duration); // easeInOutCubic scroll animation
		//return start + (end - start) * (elapsed / duration); // linear scroll animation
	};

	var smoothScroll = function($end, $duration, $callback) {
		var duration = $duration || 500;
		var start = window.pageYOffset;
		var end = $end;

		var clock = Date.now();

		var step = function(){
			var elapsed = Date.now() - clock;
			window.scroll(0, position(start, end, elapsed, duration));
			if (elapsed > duration) {
				if (typeof $callback === 'function') {
					$callback();
				}
			} else {
				requestAnimationFrame(step);
			}
		};
		step();
	};

	return function($end, $duration, $callback){
		smoothScroll($end, $duration, $callback);
	};

})();

export default SmoothScroll;
